import { BaseButton } from 'components'
import { usePageTitle } from 'hooks'
import BasePage from 'pages/base-page/base-page.page'
import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'
import { routeService, stringService } from 'services'

import './error.scss'
const noMoreAvailable = 'NO_MORE_AVAILABLE'

const ErrorPage: React.FC = () => {
  const { t } = useTranslation()
  const { search } = useLocation()

  const searchParams = useMemo(() => new URLSearchParams(search), [search])
  const [title, setTitle] = useState('')
  const [desc, setDesc] = useState('')

  useEffect(() => {
    let errorTitle = 'general'
    if (searchParams.get('errorCode') === noMoreAvailable) {
      errorTitle = noMoreAvailable.toLowerCase()
    }
    if (searchParams.get('errorCode') === 'registration') {
      errorTitle = 'registration'
    }

    setTitle(stringService.capitalizeFirstLetter(t(`error_page.${errorTitle}.title`))!)
    setDesc(stringService.capitalizeFirstLetter(t(`error_page.${errorTitle}.desc`))!)
  }, [searchParams])

  usePageTitle(title!)

  return (
    <BasePage pageClass="edisu-page-error">
      <div className="content ion-padding">
        <h2>{title}</h2>

        <p>{desc}</p>
        <div className="links">
          {searchParams.get('errorCode') === 'registration' ? (
            <Link to={routeService.generateRoutePath('/registration')}>
              <BaseButton label={t('register')} />
            </Link>
          ) : (
            <Link to={routeService.generateRoutePath('/')}>
              <BaseButton label={t('try_again')} />
            </Link>
          )}
        </div>
      </div>
    </BasePage>
  )
}

export default ErrorPage
